import React, { useRef } from 'react';

import AutoComplete from './AutoComplete';
import Tag from './Tag';

const TagsInput = ({ values, setValues, dispatchValues, suggestions }) => {
    const inputRef = useRef();
    const tagValues = values.filter((v, i) => i !== values.length - 1);
    const lastValue = values[values.length - 1];
    const placeholder = values.length === 1 ? 'Sök efter beskrivning' : '';

    const setLastValue = (value) => {
        values = [...values];
        values[values.length - 1] = value;
        setValues(values);
    };

    const deleteIndex = (index) => {
        const newValues = values.filter((v, i) => i !== index);
        setValues(newValues);
    };

    const tryCreateTag = () => {
        const input = values[values.length - 1];
        const canCreate = input !== '' && !tagValues.some((v) => v === input);
        if (canCreate) {
            values = [...values];
            values.push('');
            setValues(values);
            focusInput();
        }
    };

    const tryRemoveLastTag = () => {
        if (values.length > 1 && values[values.length - 1] === '') {
            const newValues = values.filter((v, i) => i !== values.length - 2);
            setValues(newValues);
        }
    };

    const onClick = (event) => {
        if (!event.target.className.includes('tag')) {
            focusInput();
        }
    };

    const focusInput = () => {
        inputRef.current.focus();
    };

    const getInputWidth = () => {
        const letters = Math.max(lastValue.length, placeholder.length);
        const minWidth = Math.max(letters + 1, 4) * 8;
        const maxWidth = 2 * 195 - 8;
        return Math.min(minWidth, maxWidth) + 'px';
    };

    const getInputPadding = () => {
        if (values.length === 1) {
            return 11.25 - 4 + 'px';
        } else {
            return '0';
        }
    };

    return (
        <>
            <div className='card d-flex flex-row flex-wrap' onClick={onClick}>
                {tagValues.map((value, index) => (
                    <Tag key={index} value={value} handleDelete={() => deleteIndex(index)} />
                ))}
                <AutoComplete
                    inputRef={inputRef}
                    value={lastValue}
                    setValue={setLastValue}
                    suggestions={suggestions}
                    placeholder={placeholder}
                    focusInput={focusInput}
                    tryCreateTag={tryCreateTag}
                    tryRemoveLastTag={tryRemoveLastTag}
                    inputStyle={{ width: getInputWidth(), paddingLeft: getInputPadding() }}
                />
            </div>
        </>
    );
};

export default TagsInput;
